import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { ShieldX } from 'lucide-react';
import type { PermissionCode } from '@solar/shared';
import { useAuth } from './AuthContext';
import { Spinner, EmptyState } from '@/components/ui/feedback';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Spinner className="min-h-screen" />;
  if (!user)
    return <Navigate to={`/dang-nhap?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (user.mustChangePassword && loc.pathname !== '/doi-mat-khau')
    return <Navigate to="/doi-mat-khau" replace />;
  return <>{children}</>;
}

/** Giao diện ẩn trang khi thiếu quyền; backend luôn kiểm tra lại quyền. */
export function RequirePerm({ perms, children }: { perms: PermissionCode[]; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(...perms))
    return (
      <EmptyState
        icon={<ShieldX className="size-6" />}
        title="Bạn không có quyền truy cập trang này"
        description="Liên hệ quản trị viên nếu bạn cần quyền này."
      />
    );
  return <>{children}</>;
}
